__turbopack_context__.v({
  "check-icon": "Footer-module__57GlhG__check-icon",
  "dark-btn": "Footer-module__57GlhG__dark-btn",
  "drawCheck": "Footer-module__57GlhG__drawCheck",
  "error-text": "Footer-module__57GlhG__error-text",
  "fadeIn": "Footer-module__57GlhG__fadeIn",
  "info": "Footer-module__57GlhG__info",
  "info-with-error": "Footer-module__57GlhG__info-with-error",
  "newsletter": "Footer-module__57GlhG__newsletter",
  "success-btn": "Footer-module__57GlhG__success-btn",
});
